import React from "react";
import { Stack, Label } from "@fluentui/react";

/**
 * Optional alert shown when file type does not match allowed types.
 */
function FileTypeMismatchAlert({ show, message }) {
  if (!show || !message) return null;
  return (
    <Stack.Item grow align="center" style={{ marginTop: "2px" }}>
      <Label style={{ fontSize: "small", color: "red", textAlign: "center" }}>
        {message}
      </Label>
    </Stack.Item>
  );
}

export default FileTypeMismatchAlert;
